import { render, staticRenderFns } from "./materialScience.vue?vue&type=template&id=35806a76"
import script from "./materialScience.vue?vue&type=script&lang=js"
export * from "./materialScience.vue?vue&type=script&lang=js"
import style0 from "./materialScience.vue?vue&type=style&index=0&id=35806a76&lang=scss&coped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\project\\fashang\\cqykdx\\student_pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35806a76')) {
      api.createRecord('35806a76', component.options)
    } else {
      api.reload('35806a76', component.options)
    }
    module.hot.accept("./materialScience.vue?vue&type=template&id=35806a76", function () {
      api.rerender('35806a76', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/academicDegree/components/materialScience.vue"
export default component.exports